import styled, { keyframes } from 'styled-components';

const indeterminateProgress = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(300%); }
`;

export const WrapperBar = styled.div`
  height: auto;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 15px;
  left: 50%;
  z-index: 99;
  padding: 2px;
  transform: translateX(-50%);
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.25);
  pointer-events: none;
  color: ${(props) => props.theme.colors.smokeWhite};
  opacity: 0.95;
`;

export const Bar = styled.progress`
  border: 1px solid ${(props) => props.theme.colors.highlightBlue};
  height: 18px;
  width: 300px;
  appearance: none;
  -webkit-appearance: none;

  ::-webkit-progress-bar {
    background-color: rgba(0, 0, 0, 0.45);
  }

  ::-webkit-progress-value {
    background: #0a3898;
    opacity: 0.85;
  }

  ::-moz-progress-bar {
    background: #0a3898;
    opacity: 0.85;
  }
`;

export const ProgressTrack = styled.div`
  width: 300px;
  height: 18px;
  position: relative;

  .percent {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    line-height: 18px;
    color: #FFFD;
    text-shadow: 0 1px 3px #0f2f7c;
  }

  progress,
  .indeterminate {
    width: 100%;
    height: 100%;
  }
`;

export const IndeterminateBar = styled.div`
    border: 1px solid ${(props) => props.theme.colors.borderBlue};
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 35%;
        background: #0a3898;
        opacity: 0.85;
        animation: ${indeterminateProgress} 1.2s ease-in-out infinite;
    }
`;
